module.exports = __webpack_public_path__ + "media/assets/images/logo-reservas-votorantim-25058a3a4656fff25c67153aa3db36f6.jpg";